import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Permission } from '../models/user'
import { ApplicationModule } from '../models/organization'
import { usePermission } from './use-permission'
import { useApplicationModule } from './use-application-module'
import type { NavigationGroup } from './use-navigation'

export const useSettingsNavigation = () => {
  const { can } = usePermission()
  const { hasModule } = useApplicationModule()
  const { t } = useI18n()

  const navigationItems = computed(() => {
    const groups: NavigationGroup[] = []
    const organizationItems: NavigationGroup['items'] = []

    if (can(Permission.ORG_MANAGE_SETTINGS)) {
      organizationItems.push({
        iconName: 'domain',
        routeName: 'settings-organization-general',
        label: t('common.common'),
      })
    }

    if (can(Permission.ORG_MANAGE_MEMBERS)) {
      organizationItems.push({
        iconName: 'group',
        routeName: 'settings-organization-members',
        label: t('organization.members'),
      })
    }

    if (can(Permission.ORG_MANAGE_SETTINGS) && !hasModule(ApplicationModule.LUMIA)) {
      organizationItems.push({
        iconName: 'contact_support',
        routeName: 'settings-organization-feedback-topics',
        label: t('settings.feedbackTopics.title'),
      })
    }

    if (can(Permission.ORG_MANAGE_SETTINGS) && hasModule(ApplicationModule.LUMIA)) {
      organizationItems.push({
        iconName: 'groups',
        routeName: 'settings-organization-teams',
        label: t('settings.teams'),
      })
    }

    if (organizationItems.length > 0) {
      groups.push({
        id: 'settings-organization',
        title: t('appContext.organization'),
        items: organizationItems,
      })
    }

    const personalItems: NavigationGroup['items'] = [
      {
        iconName: 'person',
        routeName: 'settings-personal',
        label: t('common.common'),
      },
    ]

    if (!hasModule(ApplicationModule.LUMIA)) {
      personalItems.push({
        iconName: 'notifications',
        routeName: 'settings-personal-notifications',
        label: t('settings.notifications.title'),
      })
    }

    groups.push({
      id: 'settings-personal',
      title: t('appContext.personal'),
      items: personalItems,
    })

    return groups
  })

  return {
    navigationItems,
  }
}
